import EmptyChatSection from './EmptyChatSection';

export default EmptyChatSection;